import React, {Component} from 'react';

import moment from "moment/moment";
import DayPickerSingleDateControllerWrapper from '../../../../../components/DatePicker/DayPickerSingleDateControllerWrapper';

export default class CalendarSlide extends Component {
  constructor(props) {
    super(props);
    this.state = {
      date : moment(),
      focused: true,
    };
  }

  handleChange = (date) => {
      this.setState({
        date: date,
      });
  };

  handleSelect = (date) => {
    this.props.handleDateSelect(this.props.slideId, this.props.elementId, date.format());
  };

  

  isDayBlocked=(day)=> day.isBefore(this.props.initialDate ? moment(new Date(this.props.initialDate)) : moment(new Date()))

  render() {
    return (
      <div style={{ textAlign: 'center' }}>
        <div style={{ display: 'inline-block' }}>
          <DayPickerSingleDateControllerWrapper
            initialDate={this.props.selectedDate ? moment(new Date(this.props.selectedDate)) : this.props.initialDate ? moment(new Date(this.props.initialDate)) : moment(new Date())}
            handleDateSelect={this.handleSelect}
            isDayBlocked={this.isDayBlocked}
          />
        </div>
      </div>
    );
  }
}

